import React, { useState, useRef } from 'react';
import './Gallery.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Watermark from '../Watermark/Watermark';

const burstImports = Array.from({ length: 20 }, (_, i) => 
  require(`../../assets/images/burst${i + 1}.png`)
);

const akiraImports = Array.from({ length: 5 }, (_, i) =>
  require(`../../assets/images/akira${i + 1}.png`)
);

const yopyImports = Array.from({ length: 8 }, (_, i) =>
  require(`../../assets/images/yopy${i + 1}.png`)
);

const aissylaImports = [
  ...Array.from({ length: 9 }, (_, i) =>
    require(`../../assets/images/aissyla${i + 1}.png`)
  ),
  require('../../assets/images/gif1.gif'),
  require('../../assets/images/gif6.gif')
];

const sasssyImports = Array.from({ length: 5 }, (_, i) =>
  require(`../../assets/images/chat${i + 1}.png`)
);

const judcocoImports = [
  require('../../assets/images/gif7.gif'),
  ...Array.from({ length: 6 }, (_, i) =>
    require(`../../assets/images/ju${i + 1}.png`)
  )
];

const shifuImports = Array.from({ length: 8 }, (_, i) =>
  require(`../../assets/images/shifu${i + 1}.png`)
);

const poiscailleImports = Array.from({ length: 5 }, (_, i) =>
  require(`../../assets/images/poiscaille${i + 1}.png`)
);

const helfynnImports = Array.from({ length: 8 }, (_, i) =>
  require(`../../assets/images/ser${i + 1}.png`)
);

const etern7llImports = Array.from({ length: 6 }, (_, i) =>
  require(`../../assets/images/idk${i + 1}.png`)
);

const bahawImports = [
  ...Array.from({ length: 7 }, (_, i) =>
    require(`../../assets/images/bahaw${i + 1}.png`)
  ),
  require('../../assets/images/gif3.gif'),
  require('../../assets/images/gif4.gif'),
  require('../../assets/images/gif8.gif')
];

const crashImports = [
  require('../../assets/images/gif5.gif'),
  ...Array.from({ length: 10 }, (_, i) =>
    require(`../../assets/images/crash${i + 1}.png`)
  )
];

const noopyImports = [
  require('../../assets/images/gif2.gif'),
  ...Array.from({ length: 6 }, (_, i) =>
    require(`../../assets/images/elf${i + 1}.png`)
  ),
  require('../../assets/images/gif9.gif'),
  require('../../assets/images/gif10.gif')
];

const fnafImports = Array.from({ length: 4 }, (_, i) =>
  require(`../../assets/images/fnaf${i + 1}.png`)
);

const vegaImports = Array.from({ length: 5 }, (_, i) =>
  require(`../../assets/images/vega${i + 1}.png`)
);

const walidImports = [
  require('../../assets/images/gif11.gif'),
  ...Array.from({ length: 7 }, (_, i) =>
    require(`../../assets/images/walid${i + 1}.png`)
  )
];

const pepitowImports = Array.from({ length: 11 }, (_, i) =>
  require(`../../assets/images/pepitow${i + 1}.png`)
);

const hasodaisuhiImports = Array.from({ length: 7 }, (_, i) =>
  require(`../../assets/images/hasodaisuhi${i + 1}.png`)
);

const manonyfoxImports = Array.from({ length: 17 }, (_, i) =>
  require(`../../assets/images/manonyfox${i + 1}.png`)
);

const chaosImports = Array.from({ length: 4 }, (_, i) =>
  require(`../../assets/images/chaos${i + 1}.png`)
);

const viperImports = Array.from({ length: 11 }, (_, i) =>
  require(`../../assets/images/viper${i + 1}.png`)
);

const loanImports = Array.from({ length: 8 }, (_, i) =>
  require(`../../assets/images/loan${i + 1}.png`)
);

const aprImports = [
  require('../../assets/images/gif12.gif'),
  require('../../assets/images/apr1.png')
];

const sadaxImports = Array.from({ length: 3 }, (_, i) =>
  require(`../../assets/images/sadax${i + 1}.png`)
);

const rampyImports = Array.from({ length: 5 }, (_, i) =>
  require(`../../assets/images/rampy${i + 1}.png`)
);

const babybelImports = Array.from({ length: 2 }, (_, i) =>
  require(`../../assets/images/babybel${i + 1}.png`)
);

function Gallery() {
  const [selectedEmote, setSelectedEmote] = useState(null);

  const modalContentRef = useRef(null);

  const setSelectedEmoteAndScroll = (emote) => {
    setSelectedEmote(emote);
    if (modalContentRef.current) {
      modalContentRef.current.scrollTop = 0;
    }
  };

  const watermarkOptions = {
    text: 'Judcoco',
    textColor: 'rgba(255, 255, 255, 0.5)',
    fontSize: '20px',
    opacity: 0.5
  };

  const burstImages = {};
  burstImports.forEach((image, index) => {
    burstImages[`burst${index + 1}`] = image;
  });

  const akiraImages = {};
  akiraImports.forEach((image, index) => {
    akiraImages[`akira${index + 1}`] = image;
  });

  const yopyImages = {};
  yopyImports.forEach((image, index) => {
    yopyImages[`yopy${index + 1}`] = image;
  });

  const aissylaImages = {};
  aissylaImports.forEach((image, index) => {
    if (index < 9) {
      aissylaImages[`aissyla${index + 1}`] = image;
    } else if (index === 9) {
      aissylaImages['gif1'] = image;
    } else {
      aissylaImages['gif6'] = image;
    }
  });

  const sasssyImages = {};
  sasssyImports.forEach((image, index) => {
    sasssyImages[`chat${index + 1}`] = image;
  });

  const judcocoImages = {};
  judcocoImports.forEach((image, index) => {
    if (index === 0) {
      judcocoImages['gif7'] = image;
    } else {
      judcocoImages[`ju${index}`] = image;
    }
  });

  const shifuImages = {};
  shifuImports.forEach((image, index) => {
    shifuImages[`shifu${index + 1}`] = image;
  });

  const poiscailleImages = {};
  poiscailleImports.forEach((image, index) => {
    poiscailleImages[`poiscaille${index + 1}`] = image;
  });

  const helfynnImages = {};
  helfynnImports.forEach((image, index) => {
    helfynnImages[`ser${index + 1}`] = image;
  });

  const etern7llImages = {};
  etern7llImports.forEach((image, index) => {
    etern7llImages[`idk${index + 1}`] = image;
  });

  const bahawImages = {};
  bahawImports.forEach((image, index) => {
    if (index < 7) {
      bahawImages[`bahaw${index + 1}`] = image;
    } else if (index === 7) {
      bahawImages['gif3'] = image;
    } else if (index === 8) {
      bahawImages['gif4'] = image;
    } else {
      bahawImages['gif8'] = image;
    }
  });

  const crashImages = {};
  crashImports.forEach((image, index) => {
    if (index === 0) {
      crashImages['gif5'] = image;
    } else {
      crashImages[`crash${index}`] = image;
    }
  });

  const noopyImages = {};
  noopyImports.forEach((image, index) => {
    if (index === 0) {
      noopyImages['gif2'] = image;
    } else if (index <= 6) {
      noopyImages[`elf${index}`] = image;
    } else if (index === 7) {
      noopyImages['gif9'] = image;
    } else {
      noopyImages['gif10'] = image;
    }
  });

  const fnafImages = {};
  fnafImports.forEach((image, index) => {
    fnafImages[`fnaf${index + 1}`] = image;
  });

  const vegaImages = {};
  vegaImports.forEach((image, index) => {
    vegaImages[`vega${index + 1}`] = image;
  });

  const walidImages = {};
  walidImports.forEach((image, index) => {
    if (index === 0) {
      walidImages['gif11'] = image;
    } else {
      walidImages[`walid${index}`] = image;
    }
  });

  const pepitowImages = {};
  pepitowImports.forEach((image, index) => {
    pepitowImages[`pepitow${index + 1}`] = image;
  });

  const hasodaisuhiImages = {};
  hasodaisuhiImports.forEach((image, index) => {
    hasodaisuhiImages[`hasodaisuhi${index + 1}`] = image;
  });

  const manonyfoxImages = {};
  manonyfoxImports.forEach((image, index) => {
    manonyfoxImages[`manonyfox${index + 1}`] = image;
  });

  const chaosImages = {};
  chaosImports.forEach((image, index) => {
    chaosImages[`chaos${index + 1}`] = image;
  });

  const viperImages = {};
  viperImports.forEach((image, index) => {
    viperImages[`rP3iV${index + 1}`] = image;
  });

  const loanImages = {};
  loanImports.forEach((image, index) => {
    loanImages[`loan${index + 1}`] = image;
  });

  const aprImages = {};
  aprImports.forEach((image, index) => {
    if(index === 0) {
      aprImages['gif12'] = image;
    } else if(index === 1) {
      aprImages['apr1'] = image;
    }
  });

  const sadaxImages = {};
  sadaxImports.forEach((image, index) => {
    sadaxImages[`sadax${index + 1}`] = image;
  });

  const rampyImages = {};
  rampyImports.forEach((image, index) => {
    rampyImages[`rampy${index + 1}`] = image;
  });

  const babybelImages = {};
  babybelImports.forEach((image, index) => {
    babybelImages[`babybel${index + 1}`] = image;
  });

  const emotes = [
    ...Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      name: `Burst ${i + 1}`,
      image: burstImages[`burst${i + 1}`],
      category: 'twitch',
      theme: 'burst', 
      description: 'Emotes de Burst'
    })),
    ...Array.from({ length: 5 }, (_, i) => ({
      id: i + 21,
      name: `Akira ${i + 1}`,
      image: akiraImages[`akira${i + 1}`],
      category: 'twitch',
      theme: 'akira',
      description: 'Emotes d\'Akira'
    })),
    ...Array.from({ length: 8 }, (_, i) => ({
      id: i + 26,
      name: `Yopy ${i + 1}`,
      image: yopyImages[`yopy${i + 1}`],
      category: 'twitch',
      theme: 'yopy',
      description: 'Emotes de Yopy'
    })),
    ...Array.from({ length: 9 }, (_, i) => ({
      id: i + 34,
      name: `Aissyla ${i + 1}`,
      image: aissylaImages[`aissyla${i + 1}`],
      category: 'twitch',
      theme: 'aissyla',
      description: 'Emotes d\'Aissyla'
    })),
    {
      id: 43,
      name: 'Gif 1',
      image: aissylaImages['gif1'],
      category: 'twitch',
      theme: 'aissyla',
      description: 'Gif d\'Aissyla'
    },
    {
      id: 44,
      name: 'Gif 6',
      image: aissylaImages['gif6'],
      category: 'twitch',
      theme: 'aissyla',
      description: 'Gif d\'Aissyla'
    },
    ...Array.from({ length: 5 }, (_, i) => ({
      id: i + 45,
      name: `Sasssy ${i + 1}`,
      image: sasssyImages[`chat${i + 1}`],
      category: 'twitch',
      theme: 'sasssy',
      description: 'Emotes de Sasssy'
    })),
    {
      id: 50,
      name: 'Gif 7',
      image: judcocoImages['gif7'],
      category: 'twitch',
      theme: 'judcoco',
      description: 'Gif de Judcoco'
    },
    ...Array.from({ length: 6 }, (_, i) => ({
      id: i + 51,
      name: `Judcoco ${i + 1}`,
      image: judcocoImages[`ju${i + 1}`],
      category: 'twitch',
      theme: 'judcoco',
      description: 'Emotes de Judcoco'
    })),
    ...Array.from({ length: 8 }, (_, i) => ({
      id: i + 57,
      name: `Shifu ${i + 1}`,
      image: shifuImages[`shifu${i + 1}`],
      category: 'twitch',
      theme: 'shifu',
      description: 'Emotes de Shifu'
    })),
    {
      id: 65,
      name: 'Poiscaille 5',
      image: poiscailleImages['poiscaille5'],
      category: 'twitch',
      theme: 'poiscaille',
      description: 'Emotes de Poiscaille'
    },
    ...Array.from({ length: 4 }, (_, i) => ({
      id: i + 66,
      name: `Poiscaille ${i + 1}`,
      image: poiscailleImages[`poiscaille${i + 1}`],
      category: 'twitch',
      theme: 'poiscaille',
      description: 'Emotes de Poiscaille'
    })),
    ...Array.from({ length: 8 }, (_, i) => ({
      id: i + 70,
      name: `Helfynn ${i + 1}`,
      image: helfynnImages[`ser${i + 1}`],
      category: 'twitch',
      theme: 'helfynn',
      description: 'Emotes de Helfynn'
    })),
    ...Array.from({ length: 6 }, (_, i) => ({
      id: i + 78,
      name: `Etern7ll ${i + 1}`,
      image: etern7llImages[`idk${i + 1}`],
      category: 'twitch',
      theme: 'etern7ll',
      description: 'Emotes d\'Etern7ll'
    })),
    ...Array.from({ length: 7 }, (_, i) => ({
      id: i + 84,
      name: `Bahaw ${i + 1}`,
      image: bahawImages[`bahaw${i + 1}`],
      category: 'twitch',
      theme: 'bahaw',
      description: 'Emotes de Bahaw'
    })),
    {
      id: 91,
      name: 'Gif 3',
      image: bahawImages['gif3'],
      category: 'twitch',
      theme: 'bahaw',
      description: 'Gif de Bahaw'
    },
    {
      id: 92,
      name: 'Gif 4',
      image: bahawImages['gif4'],
      category: 'twitch',
      theme: 'bahaw',
      description: 'Gif de Bahaw'
    },
    {
      id: 93,
      name: 'Gif 8',
      image: bahawImages['gif8'],
      category: 'twitch',
      theme: 'bahaw',
      description: 'Gif de Bahaw'
    },
    {
      id: 94,
      name: 'Gif 5',
      image: crashImages['gif5'],
      category: 'twitch',
      theme: 'crash',
      description: 'Gif de Crash'
    },
    ...Array.from({ length: 10 }, (_, i) => ({
      id: i + 95,
      name: `Crash ${i + 1}`,
      image: crashImages[`crash${i + 1}`],
      category: 'twitch',
      theme: 'crash',
      description: 'Emotes de Crash'
    })),
    {
      id: 105,
      name: 'Gif 2',
      image: noopyImages['gif2'],
      category: 'twitch',
      theme: 'noopy',
      description: 'Gif de Noopy'
    },
    ...Array.from({ length: 6 }, (_, i) => ({
      id: i + 106,
      name: `Noopy ${i + 1}`,
      image: noopyImages[`elf${i + 1}`],
      category: 'twitch',
      theme: 'noopy',
      description: 'Emotes de Noopy'
    })),
    {
      id: 112,
      name: 'Gif 9',
      image: noopyImages['gif9'],
      category: 'twitch',
      theme: 'noopy',
      description: 'Gif de Noopy'
    },
    {
      id: 113,
      name: 'Gif 10',
      image: noopyImages['gif10'],
      category: 'twitch',
      theme: 'noopy',
      description: 'Gif de Noopy'
    },
    ...Array.from({ length: 4 }, (_, i) => ({
      id: i + 114,
      name: `Fnaf ${i + 1}`,
      image: fnafImages[`fnaf${i + 1}`],
      category: 'twitch',
      theme: 'fnaf',
      description: 'Emotes de Fnaf'
    })),
    ...Array.from({ length: 5 }, (_, i) => ({
      id: i + 118,
      name: `Vega ${i + 1}`,
      image: vegaImages[`vega${i + 1}`],
      category: 'twitch',
      theme: 'vega',
      description: 'Emotes de Vega'
    })),
    {
      id: 123,
      name: 'Gif 11',
      image: walidImages['gif11'],
      category: 'twitch',
      theme: 'walid',
      description: 'Gif de Walid'
    },
    ...Array.from({ length: 7 }, (_, i) => ({
      id: i + 124,
      name: `Walid ${i + 1}`,
      image: walidImages[`walid${i + 1}`],
      category: 'twitch',
      theme: 'walid',
      description: 'Emotes de Walid'
    })),
    ...Array.from({ length: 11 }, (_, i) => ({
      id: i + 131,
      name: `Pepitow ${i + 1}`,
      image: pepitowImages[`pepitow${i + 1}`],
      category: 'tiktok',
      theme: 'pepitow',
      description: 'Emotes de Pepitow'
    })),
    ...Array.from({ length: 7 }, (_, i) => ({
      id: i + 142,
      name: `Hasodaisuhi ${i + 1}`,
      image: hasodaisuhiImages[`hasodaisuhi${i + 1}`],
      category: 'twitch',
      theme: 'hasodaisuhi',
      description: 'Emotes de Hasodaisuhi'
    })),
    ...Array.from({ length: 17 }, (_, i) => ({
      id: i + 153,
      name: `Manonyfox ${i + 1}`,
      image: manonyfoxImages[`manonyfox${i + 1}`],
      category: 'tiktok',
      theme: 'manonyfox',
      description: 'Emotes de Manonyfox'
    })),
    ...Array.from({ length: 4 }, (_, i) => ({
      id: i + 157,
      name: `Chaos ${i + 1}`,
      image: chaosImages[`chaos${i + 1}`],
      category: 'tiktok',
      theme: 'chaos',
      description: 'Emotes de Chaos Engine'
    })),
    ...Array.from({ length: 11 }, (_, i) => ({
      id: i + 168,
      name: `rP3iV ${i + 1}`,
      image: viperImages[`rP3iV${i + 1}`],
      category: 'tiktok',
      theme: 'rP3iV',
      description: 'Emotes de rP3iV'
    })),
    ...Array.from({ length: 8 }, (_, i) => ({
      id: i + 179,
      name: `Loan ${i + 1}`,
      image: loanImages[`loan${i + 1}`],
      category: 'tiktok',
      theme: 'loan',
      description: 'Emotes de Loan'
    })),
    {
      id: 187,
      name: 'Gif 12',
      image: aprImages['gif12'],
      category: 'tiktok',
      theme: 'apr',
      description: 'Gif du Pack apr'
    },
    {
      id: 188,
      name: 'Apr 1',
      image: aprImages['apr1'],
      category: 'tiktok',
      theme: 'apr',
      description: 'Emote du Pack apr'
    },
    ...Array.from({ length: 3 }, (_, i) => ({
      id: i + 189,
      name: `Sadax ${i + 1}`,
      image: sadaxImages[`sadax${i + 1}`],
      category: 'tiktok',
      theme: 'sadax',
      description: 'Emotes de Sadax'
    })),
    ...Array.from({ length: 5 }, (_, i) => ({
      id: i + 192,
      name: `Rampy ${i + 1}`,
      image: rampyImages[`rampy${i + 1}`],
      category: 'tiktok',
      theme: 'rampy',
      description: 'Emotes de Rampy'
    })),
    ...Array.from({ length: 2 }, (_, i) => ({
      id: i + 197,
      name: `Babybel ${i + 1}`,
      image: babybelImages[`babybel${i + 1}`],
      category: 'tiktok',
      theme: 'babybel',
      description: 'Emotes de Babybel'
    }))
  ];

  const themes = {
    burst: {
      name: 'Pack Burst',
      description: 'Collection d\'emotes Burst'
    },
    akira: {
      name: 'Pack Akira', 
      description: 'Collection d\'emotes Akira'
    },
    yopy: {
      name: 'Pack Yopy',
      description: 'Collection d\'emotes Yopy'
    },
    aissyla: {
      name: 'Pack Aissyla',
      description: 'Collection d\'emotes Aissyla'  
    },
    sasssy: {
      name: 'Pack Sasssy',
      description: 'Collection d\'emotes Sasssy'
    },
    judcoco: {
      name: 'Pack Judcoco',
      description: 'Collection d\'emotes Judcoco'
    },
    shifu: {
      name: 'Pack Shifu',
      description: 'Collection d\'emotes Shifu'
    },
    poiscaille: {
      name: 'Pack Poiscaille',
      description: 'Collection d\'emotes Poiscaille'
    },
    helfynn: {
      name: 'Pack Helfynn',
      description: 'Collection d\'emotes Helfynn'
    },
    etern7ll: {
      name: 'Pack Etern7ll',
      description: 'Collection d\'emotes Etern7ll'
    },
    bahaw: {
      name: 'Pack Bahaw',
      description: 'Collection d\'emotes Bahaw'
    },
    crash: {
      name: 'Pack Crash',
      description: 'Collection d\'emotes Crash'
    },
    noopy: {
      name: 'Pack Noopy',
      description: 'Collection d\'emotes Noopy'
    },
    fnaf: {
      name: 'Pack Fnaf',
      description: 'Collection d\'emotes Fnaf'
    },
    vega: {
      name: 'Pack Vega',
      description: 'Collection d\'emotes Vega'
    },
    walid: {
      name: 'Pack Walid',
      description: 'Collection d\'emotes Walid'
    },
    pepitow: {
      name: 'Pack Pepitow',
      description: 'Collection d\'emotes Pepitow'
    },
    hasodaisuhi: {
      name: 'Pack Hasodaisuhi',
      description: 'Collection d\'emotes Hasodaisuhi'
    },
    manonyfox: {
      name: 'Pack Manonyfox',
      description: 'Collection d\'emotes Manonyfox'
    },
    chaos: {
      name: 'Pack Chaos Engine',
      description: 'Collection d\'emotes Chaos Engine'
    },
    rP3iV: {
      name: 'Pack rP3iV',
      description: 'Collection d\'emotes rP3iV'
    },
    loan: {
      name: 'Pack Loan',
      description: 'Collection d\'emotes Loan'
    },
    apr: {
      name: 'Pack apr',
      description: 'Collection d\'emotes apr'
    },
    sadax: {
      name: 'Pack Sadax',
      description: 'Collection d\'emotes Sadax'
    },
    rampy: {
      name: 'Pack Rampy',
      description: 'Collection d\'emotes Rampy'
    },
    babybel: {
      name: 'Pack Babybel',
      description: 'Collection d\'emotes Babybel'
    }
  };

  const openEmoteDetails = (emote) => {
    setSelectedEmote(emote);
  };

  const closeEmoteDetails = () => {
    setTimeout(() => {
      setSelectedEmote(null);
    }, 300);
  };

  const getRelatedEmotes = (currentEmote) => {
    return emotes.filter(emote => 
      emote.theme === currentEmote.theme && emote.id !== currentEmote.id
    );
  };

  const preventRightClick = (e) => {
    e.preventDefault();
    alert("Ces emotes sont protégées. Merci de ne pas essayer de les télécharger.");
  };

  const preventDragStart = (e) => {
    e.preventDefault();
  };

  return (
    <div className="gallery" onContextMenu={preventRightClick}>
      <div className="gallery-grid">
        {Object.entries(themes).map(([themeId, theme]) => (
          <div key={themeId} className="emote-card">
            <div className="image-container">
              <Watermark 
                text={watermarkOptions.text} 
                textColor={watermarkOptions.textColor} 
                fontSize={watermarkOptions.fontSize} 
                opacity={watermarkOptions.opacity}
                isPreviewMain={true}
              >
                <img 
                  src={emotes.find(emote => emote.theme === themeId)?.image}
                  alt={theme.name}
                  onDragStart={preventDragStart}
                />
              </Watermark>
            </div>
            <div className="emote-info">
              <h3>{theme.name}</h3>
              <span className="category">
                {emotes.filter(e => e.theme === themeId).length} emotes
              </span>
            </div>
            <div className="emote-overlay">
              <div className="overlay-content">
                <h3>{theme.name}</h3>
                <button onClick={() => openEmoteDetails(emotes.find(e => e.theme === themeId))}>
                  Voir les emotes
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedEmote && (
        <div className="emote-modal" onContextMenu={preventRightClick}>
          <div className="modal-overlay" onClick={closeEmoteDetails}></div>
          <div className="modal-content" ref={modalContentRef}>
            <button className="close-button" onClick={closeEmoteDetails}>
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <div className="modal-main">
              <div className="emote-details">
                <div className="emote-preview">
                  <Watermark text={watermarkOptions.text} textColor={watermarkOptions.textColor} fontSize={watermarkOptions.fontSize} opacity={watermarkOptions.opacity}>
                    <img 
                      src={selectedEmote.image} 
                      alt={selectedEmote.name} 
                      onDragStart={preventDragStart}
                    />
                  </Watermark>
                </div>
                <div className="emote-info">
                  <h2>{themes[selectedEmote.theme].name}</h2>
                  <span className="category">{selectedEmote.category}</span>
                  <p className="description">{selectedEmote.description}</p>
                </div>
              </div>

              <div className="related-emotes">
                <h3>Autres emotes du pack</h3>
                <div className="related-grid">
                  {getRelatedEmotes(selectedEmote).map(relatedEmote => (
                    <div 
                      key={relatedEmote.id} 
                      className="related-emote"
                      onClick={() => setSelectedEmoteAndScroll(relatedEmote)}
                    >
                      <Watermark text={watermarkOptions.text} textColor={watermarkOptions.textColor} fontSize={watermarkOptions.fontSize} opacity={watermarkOptions.opacity}>
                        <img 
                          src={relatedEmote.image} 
                          alt={relatedEmote.name} 
                          onDragStart={preventDragStart}
                        />
                      </Watermark>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;